import {
  createScopedUiRepository,
  type ScopedStoredRecord,
} from "@/storage/scopedUiRepository";
import { UI_SIDEBAR_ITEMS_STORE } from "@/storage/uiDatabase";
import type { UiSidebarItem } from "@/types/ui";

export interface StoredUiSidebarItem extends UiSidebarItem, ScopedStoredRecord {}

export const EMPTY_UI_SIDEBAR_ITEMS: readonly StoredUiSidebarItem[] =
  Object.freeze([]);

const uiSidebarItemsRepository = createScopedUiRepository<
  UiSidebarItem,
  StoredUiSidebarItem
>({
  emptySnapshot: EMPTY_UI_SIDEBAR_ITEMS,
  sortRecords: sortSidebarItems,
  storeName: UI_SIDEBAR_ITEMS_STORE,
});

export const getUiSidebarItemsSnapshot = uiSidebarItemsRepository.getSnapshot;
export const subscribeUiSidebarItems = uiSidebarItemsRepository.subscribe;
export const hydrateUiSidebarItems = uiSidebarItemsRepository.hydrate;
export const replaceUiSidebarItems = uiSidebarItemsRepository.replace;
export const clearUiSidebarItems = uiSidebarItemsRepository.clear;
export const upsertUiSidebarItem = uiSidebarItemsRepository.upsert;
export const removeUiSidebarItem = uiSidebarItemsRepository.remove;
export const removeUiSidebarItems = uiSidebarItemsRepository.removeMany;

function sortSidebarItems<T extends UiSidebarItem>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => (
    a.position - b.position
    || a.name.localeCompare(b.name)
    || a.uuid.localeCompare(b.uuid)
  ));
}
